import React, { lazy, Suspense, useContext } from 'react'
import { AuthContext, AUTH_PROVIDER } from './authContextObject'
import ClerkAuthProvider from './ClerkAuthProvider'

// Loaded only when REACT_APP_AUTH_PROVIDER=supabase, so the default build never fetches the
// Supabase client (no supabase.co traffic).
const SupabaseAuthProvider = lazy(() => import('./SupabaseAuthProvider'))

export { AuthContext, AUTH_PROVIDER }

export const useAuth = () => {
  const context = useContext(AuthContext)
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider')
  }
  return context
}

export const AuthProvider = ({ children }) => {
  if (AUTH_PROVIDER === 'supabase') {
    return (
      <Suspense fallback={null}>
        <SupabaseAuthProvider>{children}</SupabaseAuthProvider>
      </Suspense>
    )
  }
  return <ClerkAuthProvider>{children}</ClerkAuthProvider>
}
